import * as Types from '../../gen/graphql-type';

import gql from 'graphql-tag';
import { Userable_All_RolesFragmentDoc } from '../query.gen-graphql';
export type User_DocWmsOrderCsvFilePolicy_ShowFragment = { allRoles: Array<{ id: string, name: Types.UserRoleName }> };

export type User_DocWmsOrderCsvFilePolicy_ShowSidebarFragment = { allRoles: Array<{ id: string, name: Types.UserRoleName }> };

export const User_DocWmsOrderCsvFilePolicy_ShowFragmentDoc = gql`
    fragment User_DOCWmsOrderCsvFilePolicy_Show on Admin {
  ...Userable_All_Roles
}
    ${Userable_All_RolesFragmentDoc}`;
export const User_DocWmsOrderCsvFilePolicy_ShowSidebarFragmentDoc = gql`
    fragment User_DOCWmsOrderCsvFilePolicy_ShowSidebar on Admin {
  ...Userable_All_Roles
}
    ${Userable_All_RolesFragmentDoc}`;